'use strict';

/**
 * Valid indicator initialization settings
 * @typedef {Object} ValidIndicatorSettings
 * @property {jQuery} container - jQuery wrapper of container to initialize the events on
 * @property {undefined|boolean} [hideIfEmpty=true]  - hide indicator if the field is empty (default=true)
 * @property {Number} [delay=500] - delay before validating field (default=500)
 */

/**
 *
 * @param {ValidIndicatorSettings} settings
 * @requires package:jquery-validation or another implementation of $element.isValid()
 */
export const initValidIndicatorEvent = settings => {
    const settingsToUse = {
        hideIfEmpty: true,
        delay: 500,
        ...settings
    };

    let typingTimer = {};
    settingsToUse.container.on('input', 'input[data-show-valid-indicator="true"]', e => {
        const $input = $(e.currentTarget);
        const inputID = $input.attr('id');
        if (typingTimer[inputID]) {
            clearTimeout(typingTimer[inputID]);
        }

        typingTimer[inputID] = setTimeout(() => {
            const shouldHideIndicator = settingsToUse.hideIfEmpty && !$input.val();
            if ($input.valid() && !shouldHideIndicator) {
                $input.siblings('.show-valid').show();
                $input.addClass('valid-indicator-active');
            } else {
                $input.siblings('.show-valid').hide();
                $input.removeClass('valid-indicator-active');
            }
        }, settings.delay);
    });
};
